// extracted by mini-css-extract-plugin
export default {"backdrop":"backdrop__72Y84","dropbox":"dropbox__v3Tju","border":"border__JQVUH","title":"title__V243j"};